import React from 'react';

export const warningIcon = (
    <svg
        data-test-id="field-fio-warning-icon"
        fill="none"
        height="20"
        viewBox="0 0 24 20"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M22.977 17.502L13.098 0.959958C12.8273 0.506482 12.3381 0.22876 11.81 0.22876C11.2819 0.22876 10.7927 0.506482 10.522 0.959958L0.643014 17.5C0.365725 17.9635 0.359103 18.5404 0.625676 19.0102C0.892249 19.48 1.39084 19.7702 1.93101 19.77H21.69C22.2302 19.7702 22.7288 19.48 22.9954 19.0102C23.2619 18.5404 23.2553 17.9635 22.978 17.5L22.977 17.502ZM13.06 5.76996L12.81 12.77H10.81L10.56 5.76996H13.06ZM10.7413 17.3344C11.0224 17.6168 11.4056 17.7738 11.804 17.77C12.66 17.77 13.31 17.119 13.31 16.27C13.31 15.42 12.659 14.77 11.804 14.77C10.972 14.77 10.31 15.42 10.31 16.27C10.3046 16.6684 10.4601 17.0521 10.7413 17.3344Z"
            fill="#EF3124"
            fillRule="evenodd"
        />
    </svg>
);
